<template>
  <div class="pagination-detail">
    <!-- Previous button -->
    <div class="frame" @click="goToPreviousPage" :class="{ 'disabled': currentPage === 1 }">
      <img
        class="ep-arrow-right-bold"
        alt="Ep arrow right bold"
        src="/img/ep-arrow-right-bold.svg"
      />
    </div>

    <!-- Generate page numbers dynamically -->
    <div 
      v-for="page in displayedPages" 
      :key="page"
      class="page-text-wrapper"
      :class="{ 'active': currentPage === page }"
      @click="goToPage(page)"
    >
      <div class="text-wrapper">{{ page === 'ellipsis' ? '...' : page }}</div>
    </div>

    <!-- Next button -->
    <div class="ep-arrow-right-bold-wrapper" @click="goToNextPage" :class="{ 'disabled': currentPage === totalPages || totalPages === 0 }">
      <img
        class="img"
        alt="Ep arrow right bold"
        src="/img/ep-arrow-right-bold-1.svg"
      />
    </div>
  </div>
</template>

<script>
// import membresData from '../../../membres.json'; // No longer needed here

export default {
  name: "PaginationDetail",
  props: {
    currentPage: {
      type: Number,
      required: true // currentPage is essential
    },
    totalPages: { // Add totalPages as a prop
      type: Number,
      required: true // totalPages is essential
    }
  },
  // data() { // Remove local data related to totalItems and itemsPerPage
    // return {
      // itemsPerPage: 5, 
      // totalItems: membresData.length 
    // }
  // },
  computed: {
    // totalPages() { // Remove this computed property, use the prop instead
      // return Math.ceil(this.totalItems / this.itemsPerPage);
    // },
    displayedPages() {
      const pages = [];
      if (this.totalPages === 0) { // Handle case with no pages
        return pages;
      }
      
      pages.push(1);
      
      // Adjust logic slightly if totalPages is very small
      let startPage = Math.max(2, this.currentPage - 1);
      let endPage = Math.min(this.totalPages - 1, this.currentPage + 1);

      if (this.totalPages <= 5) { // If 5 or less pages, show all
        startPage = 2;
        endPage = this.totalPages -1;
      } else {
        if (this.currentPage <= 3) {
            startPage = 2;
            endPage = Math.min(this.totalPages - 1, 4); // Show 1, 2, 3, 4, ..., last
        } else if (this.currentPage >= this.totalPages - 2) {
            startPage = Math.max(2, this.totalPages - 3); // Show 1, ..., last-3, last-2, last-1, last
            endPage = this.totalPages - 1;
        }
        // Ellipsis logic
        if (startPage > 2) {
          pages.push('ellipsis');
        }
      }
      
      for (let i = startPage; i <= endPage; i++) {
        if (i > 0) pages.push(i); // Ensure i is positive
      }
      
      if (this.totalPages > 5 && endPage < this.totalPages - 1) {
        pages.push('ellipsis');
      }
      
      if (this.totalPages > 1) {
        pages.push(this.totalPages);
      }
      
      // Remove duplicates that might arise from small totalPages values
      return [...new Set(pages)].filter(p => p !== 0);
    }
  },
  methods: {
    goToPage(page) {
      if (page !== 'ellipsis' && page !== this.currentPage) {
        this.$emit('page-changed', page);
      }
    },
    goToNextPage() {
      if (this.currentPage < this.totalPages) {
        this.$emit('page-changed', this.currentPage + 1);
      }
    },
    goToPreviousPage() {
      if (this.currentPage > 1) {
        this.$emit('page-changed', this.currentPage - 1);
      }
    }
  }
};
</script>


<style>
.pagination-detail {
  z-index: 10;
  align-items: center;
  background-color: #e6e3b580;
  border-radius: 8px;
  display: inline-flex;
  gap: 7px;
  height: 61px;
  margin: 8px auto 16px auto;
  width: fit-content;
  /* right: 20; */
  /* left: 1056px; */
  /* position: relative; */
  /* top: 831px; */
}

/* Center pagination on all screens but keep it compact */
@media (min-width: 769px) {
  .pagination-detail {
    margin: 12px auto 20px auto;
    display: inline-flex;
    width: fit-content;
  }
}

.pagination-detail .disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pagination-detail .page-text-wrapper {
  cursor: pointer;
}

.pagination-detail .page-text-wrapper:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

.pagination-detail .frame {
  align-items: center;
  border-radius: 100px;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 10px;
  justify-content: center;
  padding: 10px;
  /* position: relative; */
  transform: rotate(90deg);
}

.pagination-detail .ep-arrow-right-bold {
  height: 24px;
  position: relative;
  transform: rotate(180deg);
  width: 24px;
}

.pagination-detail .active {
  align-items: center;
  border: 0.5px solid;
  border-color: #000000;
  border-radius: 4px;
  display: inline-flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
  padding: 4px 8px 0px 8px;
  /* position: relative; */
}

.pagination-detail .text-wrapper {
  align-self: stretch;
  color: #000000;
  font-family: "Mona-Sans-Light", Helvetica;
  font-size: 20px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 24px;
  margin-top: -0.50px;
  /* position: relative; */
}

.pagination-detail .page-text-wrapper {
  align-items: center;
  border-radius: 4px;
  display: inline-flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
  padding: 2px 8px;
  /* position: relative; */
}

.pagination-detail .ep-arrow-right-bold-wrapper {
  align-items: center;
  border-radius: 100px;
  display: flex;
  gap: 10px;
  height: 48px;
  justify-content: center;
  padding: 10px;
  position: relative;
  transform: rotate(180deg);
  width: 48px;
}

.pagination-detail .img {
  height: 24px;
  position: relative;
  transform: rotate(90deg);
  width: 24px;
}
@media (max-width: 773px){
  .pagination-detail {
    width: fit-content;
    overflow: visible;
    margin: 8px auto 16px auto;
    display: inline-flex;
  }
}
</style>